import getprices_lt25 from "./swiss/getprices_lt25.json";
import getprices_gt25 from "./swiss/getprices_gt25.json";
//import Axios from "axios";


// const getData = async ()=>{
//     var res = await Axios.get("http://driveandscan.de/api_v2/getPrices.php");
//     return res.data;
// }



export const calculatePrice =  (average, count) => {
    // If no average or zero
    if(!average)return 0;
    if(!count)return 0;
//let data =  getData;
    // if avarage less than or equal to 25
  if (average <= 25 && average !== 0) {

    var result = getprices_lt25.find(obj => {
      return obj.dentCount == count;
    });
    return result && parseInt(result.price) ;
  } else {
    // if avarage grater than 25
    var resultplus = getprices_gt25.find(obj => {
      return obj.dentCount == count;
    });
    return resultplus && parseInt(resultplus.price);
  }
  //return average
};
